import type { Errors } from 'io-ts';
import { report } from 'io-ts-human-reporter';
import { left } from 'fp-ts/Either';

import { AppError } from './AppError';

export class ValidationError extends AppError {
    // note: we actually do not store the raw list of errors
    // since it is pretty cryptic and slows down the devtools
    constructor(_originalError: Errors, messages: string[]) {
        super('ValidationError', null, 'Invalid data', messages);
    }
}

export const createValidationError = (originalError: Errors) =>
    new ValidationError(originalError, report(left(originalError)));
